import React, { useState, useContext } from 'react';
import { Resource } from '../../../../../index';
import MenuArrow from '../../../../../assets/icons/menu-arrow.svg';
import useDidUpdateEffect from '../../../../../hooks/useDidUpdateEffect';
import { FormularioRespondidoContext } from '../../../../../context/FormularioRespondidoContext';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface IProps {
	grupo: any;
	setIsOpened: (isOpened: boolean) => void;
	isOpened: boolean;
	formularioId?: number;
}

const HeaderDeGrupo: React.FC<IProps> = ({ grupo, isOpened, setIsOpened, formularioId }) => {
	const { mostrarTodosOsCollapses } = useContext(FormularioRespondidoContext);

	const {
		pontuacao = undefined,
		pontuacaoMaxima = undefined,
		setorNome = undefined,
		setorId = undefined,
	} = grupo.resultadoAgrupadoPorGrupo === null ? {} : grupo.resultadoAgrupadoPorGrupo;

	const pontuacaoFinal = ((100 * pontuacao) / pontuacaoMaxima).toFixed(2)
	const usarContagemDePerguntas = formularioId === 410;
	const perguntasDoGrupo = grupo.listResultadoFormulario || [];
	const perguntasRespondidas = perguntasDoGrupo.filter(pergunta => {
		if (typeof pergunta.resposta === 'string') return pergunta.resposta.trim().length > 0;
		return pergunta.resposta !== null && pergunta.resposta !== undefined;
	}).length;
	const totalDePerguntas = perguntasDoGrupo.length;
	const percentualDePerguntasRespondidas = totalDePerguntas > 0
		? ((100 * perguntasRespondidas) / totalDePerguntas).toFixed(2)
		: '0.00';

	useDidUpdateEffect(() => setIsOpened(mostrarTodosOsCollapses), [mostrarTodosOsCollapses]);

	return (
		<div
			className="py-2 px-4 rounded shadow-sm border d-flex justify-content-between w-100"
			style={{ cursor: 'pointer' }}
			id={`heading-${grupo.id}`}
			onClick={() => setIsOpened(!isOpened)}
		>
			{
				grupo.resultadoAgrupadoPorGrupo !== null
					? <React.Fragment>
						<div className="d-flex flex-row justify-content-between w-100">
							<div className='d-flex align-items-center justify-content-center'>
								<p className='mb-0'>{setorNome !== null && setorId > 0 ? `[${setorNome}]` : ""}</p>
								<p className='mb-0'>{`${grupo.nome}`}</p>
							</div>
							<div className='d-flex align-items-center justify-content-center'>
								
								{
									usarContagemDePerguntas
										? totalDePerguntas === 0
											? <p className='mr-3 mb-0'>(NA)</p>
											: <div className='d-flex mr-3'>
												<span>{perguntasRespondidas}</span>
												<span className="mx-2">|</span>
												<span>{totalDePerguntas}</span>
												<span className="mx-2">|</span>
												<span>{percentualDePerguntasRespondidas}%</span>
											</div>
										: pontuacaoMaxima == 0 || pontuacao == null
											? 	<p className='mr-3 mb-0'>(NA)</p>
										: 	<div className='d-flex mr-3'>
												<span>{pontuacao}</span>
												<span className="mx-2">|</span>
												<span>{pontuacaoMaxima}</span>
												<span className="mx-2">|</span>
												<span>{pontuacaoFinal}%</span>
											</div>
								}
							</div>
						</div>
					</React.Fragment>
					: <p className='mb-0'>{grupo.nome}</p>
			}
			<ChevronUp
				className='_IMPRIMIR_OMITIR_'
				style={{
					transform: isOpened ? 'rotate(180deg)' : '',
					transition: 'transform 550ms ease',
				}}
			/>
		</div>
	);
};

export default HeaderDeGrupo;
